import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { Toast } from 'primereact/toast'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import * as yup from "yup";

const ViewAffiliate = () => {

    const toast = useRef(null)
    const [affiliateData, setAffiliateData] = useState([])

    const navigate = useNavigate()

    const { id } = useParams()
    
    const schema = yup.object({
        status: yup.string(),
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    useEffect(() => {
        getAffiliates()
    }, [])
    
    const getAffiliates = async () => {
        await ApiHelper.get(`${API_ENDPOINTS.AFFILIATES}/${id}`).then((res) => {
        // console.log('res: ', res);
        if (res.status === 200) {
            setAffiliateData(res.data.data)
            reset({status: res.data.data.status})
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.AFFILIATES}/update-status/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/affiliates')
                }, 900)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    return (
        <>
        <Toast ref={toast} />
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"> <p className="breadcrumb-item active mb-0" aria-current="page"> Affiliates </p> </span></h4>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <form onSubmit={handleSubmit(update)}>
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label className="fw-semibold text-muted">Affiliate Code</label>
                                                <p className="mb-0">{affiliateData?.affiliateCode || "-"}</p>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="fw-semibold text-muted">Full Name</label>
                                                <p className="mb-0">{affiliateData?.fullName || "-"}</p>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="fw-semibold text-muted">Email</label>
                                                <p className="mb-0">{affiliateData?.email || "-"}</p>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="fw-semibold text-muted">Mobile Number</label>
                                                <p className="mb-0">{affiliateData?.mobileNumber || "-"}</p>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="fw-semibold text-muted">Company Name</label>
                                                <p className="mb-0">{affiliateData?.companyName || "-"}</p>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="fw-semibold text-muted">Website / Social Profile</label>
                                                <br/>
                                                <a href={ affiliateData?.websiteOrSocialProfile?.startsWith("http") ? affiliateData?.websiteOrSocialProfile : `https://${affiliateData?.websiteOrSocialProfile}` } target="_blank" rel="noopener noreferrer">
                                                    {affiliateData?.websiteOrSocialProfile || '-'}
                                                </a>
                                            </div>                                            

                                            <div className="col-md-4 mb-3">
                                                <label className="fw-semibold text-muted">PAN Number</label>
                                                <p className="mb-0">{affiliateData?.panNumber || "-"}</p>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="fw-semibold text-muted">GST Number</label>
                                                <p className="mb-0">{affiliateData?.gstNumber || "-"}</p>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="fw-semibold text-muted">Commission</label>
                                                <p className="mb-0">{affiliateData?.commissionPercentage}%</p>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="fw-semibold text-muted">Payment Method</label>
                                                <p className="mb-0">{affiliateData?.paymentMethod}</p>
                                            </div>

                                            {affiliateData?.paymentMethod === "upi" && (
                                                <div className="col-md-4 mb-3">
                                                    <label className="fw-semibold text-muted">UPI ID</label>
                                                    <p className="mb-0">{affiliateData?.upiId}</p>
                                                </div>
                                            )}

                                            {affiliateData?.paymentMethod === "bank" && (
                                                <>
                                                    <div className="col-md-4 mb-3">
                                                        <label className="fw-semibold text-muted">Account Holder</label>
                                                        <p className="mb-0">{affiliateData?.accountHolderName}</p>
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                        <label className="fw-semibold text-muted">Bank Name</label>
                                                        <p className="mb-0">{affiliateData?.bankName}</p>
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                        <label className="fw-semibold text-muted">Account Number</label>
                                                        <p className="mb-0">{affiliateData?.accountNumber}</p>
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                        <label className="fw-semibold text-muted">IFSC Code</label>
                                                        <p className="mb-0">{affiliateData?.ifscCode}</p>
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                        <label className="fw-semibold text-muted">Cancelled Cheque</label>
                                                        <br/>
                                                        {affiliateData?.cancelledCheque ? (
                                                            <div>
                                                                <Link to={`${process.env.REACT_APP_BASE_URL}/${affiliateData?.cancelledCheque}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary" > View Document </Link>
                                                            </div>
                                                        ) : ('-')}
                                                    </div>
                                                </>
                                            )}


                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Status</label>
                                            <select className="form-select" defaultValue={affiliateData?.status} {...register("status")}>
                                                <option value="pending">Pending</option>
                                                <option value="approved">Approved</option>
                                                <option value="rejected">Rejected</option>
                                            </select>
                                        </div>
                                        <div className="text-end mt-3">
                                            <button type="submit" className="btn btn-primary"> Update Status </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout> 
        </>
    )
}

export default ViewAffiliate
